import { render, staticRenderFns } from "./SafeHyperlinkComponent.vue?vue&type=template&id=3901151f&"
import script from "./SafeHyperlinkComponent.vue?vue&type=script&lang=js&"
export * from "./SafeHyperlinkComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports